import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MaterialModule } from '../material/material.module';
import { VerActividadesModule } from './ver-actividades/ver-actividades.module';
import { AccionesActividadModule } from './acciones-actividad/acciones-actividad.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxPermissionsModule.forChild(),
    VerActividadesModule,
    MaterialModule,
    AccionesActividadModule,
  ],
  declarations: [
  ],
  entryComponents: [
  ],
  exports: [
    VerActividadesModule,
    AccionesActividadModule
  ],
})
export class ActividadesModule { }
